import { render, staticRenderFns } from "./TransferComplete.vue?vue&type=template&id=d6ff95b8&"
import script from "./TransferComplete.vue?vue&type=script&lang=js&"
export * from "./TransferComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TransferComplete.vue"
export default component.exports